import { IconButton, styled } from "@mui/material";

const ActionButton = styled(IconButton)(() => ({
  width: 36,
  height: 36,
  borderRadius: 12,
  backgroundColor: "#fff",
  border: "1px solid #e5e7eb",
  boxShadow: "0px 1px 2px rgba(0,0,0,0.04), 0px 0px 0px 1px rgba(0,0,0,0.02)",
  transition: "all 0.15s ease",
  "&:hover": {
    backgroundColor: "#f3f4f6",
    boxShadow: "0px 2px 4px rgba(0,0,0,0.06), 0px 0px 0px 1px rgba(0,0,0,0.04)",
  },
  "& svg": {
    fontSize: "18px",
  },
}));

export default ActionButton;
